(function () {
  const CHECKBOX_SELECTOR = '[data-agreement-checkbox]';
  const SUBMIT_SELECTOR = '[data-agreement-submit]';
  const CONTRACT_MODAL_TRIGGER_SELECTOR = '[data-contract-modal-trigger]';
  const SUMMARY_SELECTOR = '.cart-drawer__summary, .cart-page__summary, .cart-summary';
  const ATTENTION_CLASS = 'cart-agreement--attention';

  /**
   * @param {Element} element
   * @returns {ParentNode}
   */
  function getAgreementScope(element) {
    return element.closest(SUMMARY_SELECTOR) ?? element.closest('cart-items-component') ?? document;
  }

  /**
   * @param {ParentNode} scope
   */
  function syncCheckoutState(scope) {
    const isChecked = isAgreementChecked(scope);

    scope.querySelectorAll(SUBMIT_SELECTOR).forEach((button) => {
      if (!(button instanceof HTMLButtonElement)) return;
      button.disabled = false;
      button.setAttribute('aria-disabled', isChecked ? 'false' : 'true');
    });
  }

  /**
   * @param {ParentNode} scope
   * @returns {boolean}
   */
  function isAgreementChecked(scope) {
    const checkbox = scope.querySelector(CHECKBOX_SELECTOR);
    return checkbox instanceof HTMLInputElement && checkbox.checked;
  }

  /**
   * @param {Element} element
   */
  function syncFromElement(element) {
    syncCheckoutState(getAgreementScope(element));
  }

  function syncAllCheckoutStates() {
    document.querySelectorAll(SUBMIT_SELECTOR).forEach((button) => {
      syncFromElement(button);
    });
  }

  function scheduleSyncAllCheckoutStates() {
    syncAllCheckoutStates();
    requestAnimationFrame(syncAllCheckoutStates);
  }

  /**
   * Safari can drop the delegated theme action when a control lives near label text.
   * This keeps the legal text buttons deterministic without relying on label bubbling.
   *
   * @param {string | null} modalId
   */
  function openContractModal(modalId) {
    if (!modalId) return;

    const openModal = () => {
      const modal = document.getElementById(modalId);
      if (!modal) return;

      if ('showDialog' in modal && typeof modal.showDialog === 'function') {
        modal.showDialog();
        return;
      }

      const dialog = modal.querySelector('dialog');
      if (dialog instanceof HTMLDialogElement && !dialog.open) {
        dialog.showModal();
      }
    };

    if (customElements.get('dialog-component')) {
      openModal();
    } else {
      customElements.whenDefined('dialog-component').then(openModal);
    }
  }

  /**
   * @param {ParentNode} scope
   */
  function triggerAgreementAttention(scope) {
    const agreement = scope.querySelector('.cart-agreement');
    if (!(agreement instanceof HTMLElement)) return;

    agreement.classList.remove(ATTENTION_CLASS);
    agreement.offsetHeight;
    agreement.classList.add(ATTENTION_CLASS);

    window.setTimeout(() => {
      agreement.classList.remove(ATTENTION_CLASS);
    }, 800);
  }

  document.addEventListener('change', (event) => {
    if (!(event.target instanceof Element)) return;

    const checkbox = event.target.closest(CHECKBOX_SELECTOR);
    if (!checkbox) return;

    checkbox.closest('.cart-agreement')?.classList.remove(ATTENTION_CLASS);
    syncFromElement(checkbox);
  });

  document.addEventListener(
    'click',
    (event) => {
      if (!(event.target instanceof Element)) return;

      const contractModalTrigger = event.target.closest(CONTRACT_MODAL_TRIGGER_SELECTOR);
      if (contractModalTrigger instanceof HTMLElement) {
        event.preventDefault();
        openContractModal(contractModalTrigger.dataset.contractModalTrigger ?? null);
        return;
      }

      const submitButton = event.target.closest(SUBMIT_SELECTOR);
      if (!(submitButton instanceof HTMLButtonElement)) return;

      const scope = getAgreementScope(submitButton);
      if (isAgreementChecked(scope)) return;

      event.preventDefault();
      event.stopPropagation();
      triggerAgreementAttention(scope);
    },
    { capture: true }
  );

  document.addEventListener('submit', (event) => {
    const submitter = /** @type {SubmitEvent} */ (event).submitter;
    if (!(submitter instanceof Element) || !submitter.matches(SUBMIT_SELECTOR)) return;

    const scope = getAgreementScope(submitter);
    if (isAgreementChecked(scope)) return;

    event.preventDefault();
    triggerAgreementAttention(scope);
  });

  document.addEventListener('shopify:section:load', scheduleSyncAllCheckoutStates);
  document.addEventListener('cart:update', scheduleSyncAllCheckoutStates);
  document.addEventListener('cart:add', scheduleSyncAllCheckoutStates);
  document.addEventListener('DOMContentLoaded', scheduleSyncAllCheckoutStates);
  window.addEventListener('pageshow', scheduleSyncAllCheckoutStates);
})();
